export const checkRetirement = (type_retirement) => {
	const pharmacy = 'farmacia';
	if (type_retirement === pharmacy) {
		return 'none';
  }
  return 'inline-block'
};
